let Form = {};

Form.init = function () {
	// TOGGLE IS_VALID CLASS ON CHECKBOX
  $('input[type="checkbox"].custom-control-input').change(function () {
    if ($(this).prop('checked')) {
      $(this).removeClass('is-invalid')
    }
  });
};

Form.init();



// WEBPACK FOOTER //
// ./scripts/components/forms.js